import HeroText from "@/components/HeroText.vue";

export const heroTextInit = {
    component: HeroText,
    name: "Hero Text",
    inputs: [
        // add inputs for eyebrow, header and body
        {
            name: "eyebrow",
            friendlyName: "Eyebrow Text",
            type: "string",
            defaultValue: "Eyebrow"
        },
        {
            name: "header",
            friendlyName: "Header Text",
            type: "string",
            defaultValue: "Header"
        },
        {
            name: "body",
            friendlyName: "Body Text",
            type: "richText",
            defaultValue: "Body"
        },
        {
            name: "cta",
            friendlyName: "CTA",
            type: "object",
            subFields: [
                {
                    name: "text",
                    friendlyName: "CTA Text",
                    type: "string",
                    defaultValue: "CTA"
                },
                {
                    name: "link",
                    friendlyName: "CTA Link",
                    type: "string",
                    defaultValue: "#"
                }
            ]
        },
        {
            name: "textAlignment",
            friendlyName: "Text Alignment",
            type: "string",
            defaultValue: "center",
            enum: ["left", "center", "right"]
        }
    ]
};
